module.exports = "/_next/static/images/row2-1-40973b43ec54a046a4b5fad9538f56c8.png";